import type { TFunction } from 'i18next';

import type { ISelectOption } from '@feathr/components';

import type { TTimeframePreset } from '../ReportsConversionsDashboardPage.utils';

export interface IPresetOption extends ISelectOption {
  id: TTimeframePreset;
}

export function buildPresetOptions(t: TFunction): IPresetOption[] {
  return [
    { id: '7d', name: t('Last 7 days') },
    { id: '30d', name: t('Last 30 days') },
    { id: '90d', name: t('Last 90 days') },
    { id: 'mtd', name: t('This month') },
    { id: 'last_month', name: t('Last month') },
    { id: 'qtd', name: t('This quarter') },
    { id: 'ytd', name: t('Year to date') },
    { id: 'custom', name: t('Custom') },
  ];
}
